import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { axiosInstance } from "../../Config";

const ContactList = () => {
  const [contacts, setContacts] = useState([]);
  const [selectedContact, setSelectedContact] = useState(null);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    fetchContacts();
  }, []);

  const fetchContacts = async () => {
    try {
      const res = await axiosInstance.get("/contactList");
      if (res.data.success) {
        setContacts(res.data.body || []);
      }
    } catch (err) {
      console.log("Fetch Contact Error:", err);
    } finally {
      setLoading(false);
    }
  };

  const deleteContact = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "green",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        await axiosInstance.delete(`/deleteContact/${id}`);
        setContacts(contacts.filter((contact) => contact.id !== id));
        Swal.fire("Deleted!", "Contact deleted successfully.", "success");
      } catch (error) {
        Swal.fire("Error!", "Failed to delete contact.", "error");
      }
    }
  };

  const filteredContacts = contacts.filter(
    (contact) =>
      contact.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      contact.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
      contact.message.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <div id="layout-wrapper">
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              <div className="title-box mb-3 pb-1 d-flex justify-content-between align-items-center">
                <h4 className="mb-0 page-title">Contact Us List</h4>
              </div>
              <div>
                <nav aria-label="breadcrumb" className="mt-1">
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to="/dashboard">
                        <i className="ri-home-4-fill me-1" /> Home
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">Contact Listings</li>
                  </ol>
                </nav>
              </div>

              <div className="card">
                <div className="card-body">
                  <div className="mb-3" style={{ maxWidth: "300px" }}>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search contacts..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>

                  {loading ? (
                    <div className="text-center py-5">
                      <div className="spinner-border text-primary" />
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-centered ">
                        <thead>
                          <tr>
                            <th>Sr No.</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Message</th>
                            <th>Date</th>
                            <th className="text-end">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredContacts.length > 0 ? (
                            filteredContacts.map((contact, index) => (
                              <tr key={contact.id}>
                                <td>{index + 1}</td>
                                <td>{contact.name}</td>
                                <td>{contact.email}</td>
                                <td style={{ maxWidth: "300px" }}>
                                  {contact.message.length > 50
                                    ? contact.message.substring(0, 50) + "..."
                                    : contact.message}
                                </td>
                                <td>
                                  {new Date(contact.created_at).toLocaleDateString()}
                                </td>
                                <td className="text-end">
                                  <button
                                    className="btn btn-soft-primary btn-sm me-1"
                                    data-bs-toggle="offcanvas"
                                    data-bs-target="#view-details"
                                    onClick={() => setSelectedContact(contact)}
                                  >
                                    <i className="ri-eye-fill"></i>
                                  </button>

                                  <button
                                    className="btn btn-soft-danger btn-sm"
                                    onClick={() => deleteContact(contact.id)}
                                  >
                                    <i className="ri-delete-bin-line"></i>
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="6" className="text-center text-muted">
                                No contacts found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="offcanvas offcanvas-end rdetails"
        tabIndex="-1"
        id="view-details"
        aria-labelledby="offcanvasRightLabel"
      >
        <div className="offcanvas-header d-block">
          <div className="d-flex align-items-center justify-content-between">
            <h5 className="offcanvas-title mb-0 fw-semibold">Contact Details</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>
        </div>
        <div className="offcanvas-body">
          {selectedContact ? (
            <>
              <div className="mt-3">
                <div className="font-size-16 fw-medium mb-1">Name:</div>
                <div className="bg-light p-2 rounded">{selectedContact.name}</div>
              </div>
              <div className="mt-3">
                <div className="font-size-16 fw-medium mb-1">Email:</div>
                <div className="bg-light p-2 rounded">{selectedContact.email}</div>
              </div>
              <div className="mt-3">
                <div className="font-size-16 fw-medium mb-1">Message:</div>
                <div className="bg-light">
                  <textarea
                    readOnly
                    className="form-control"
                    rows="10"
                    value={selectedContact.message}
                    style={{
                      resize: "none",
                      backgroundColor: "#f8f9fa",
                      border: "1px solid #ced4da",
                    }}
                  />
                </div>
              </div>
              <div className="mt-3">
                <div className="font-size-16 fw-medium mb-1">Date:</div>
                <div className="bg-light p-2 rounded">
                  {new Date(selectedContact.created_at).toLocaleString()}
                </div>
              </div>
            </>
          ) : (
            <div className="text-center py-5">
              <p className="text-muted">No contact selected</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ContactList;
